import { render, staticRenderFns } from "./productPayResult.vue?vue&type=template&id=08ff030d&scoped=true&"
import script from "./productPayResult.vue?vue&type=script&lang=js&"
export * from "./productPayResult.vue?vue&type=script&lang=js&"
import style0 from "./productPayResult.vue?vue&type=style&index=0&id=08ff030d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff030d",
  null
  
)

export default component.exports